<template>
  <PointsViewer :collname="collname" />
</template>

<script>
import PointsViewer from '../components/PointsViewer.vue';

export default {
    components: {
        PointsViewer,
    },

    props: {
	collname: '',
    },
};
</script>
